import 'react-app-polyfill/ie11'; 

import React from 'react';
import ReactDOM from 'react-dom';
import {
    combineReducers,
    createStore
} from 'redux';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { injectGlobal, ThemeProvider } from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import createHistory from 'history/createBrowserHistory';
import { appReducer } from './reducers';
import App from './App';

import * as serviceWorker from './serviceWorker';
import { serviceConstants } from './services';

const fontPath = serviceConstants.PathConst.WEB_BASE_URL + '/static/fonts/';

injectGlobal`
@font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 300;
    src: local('Montserrat Light'), local('Montserrat-Light'),
            url(${fontPath}montserrat-v11-latin-300.woff2) format('woff2'),
            url(${fontPath}montserrat-v11-latin-300.woff) format('woff');
    }
    
    @font-face {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        src: local('Montserrat Regular'), local('Montserrat-Regular'),
            url(${fontPath}montserrat-v11-latin-regular.woff2) format('woff2'),
            url(${fontPath}montserrat-v11-latin-regular.woff) format('woff');
    }
    
    @font-face {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        src: local('Montserrat Medium'), local('Montserrat-Medium'),
            url(${fontPath}montserrat-v11-latin-500.woff2) format('woff2'),
            url(${fontPath}montserrat-v11-latin-500.woff) format('woff');
    }
    
    @font-face {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        src: local('Montserrat Bold'), local('Montserrat-Bold'),
            url(${fontPath}montserrat-v11-latin-700.woff2) format('woff2'),
            url(${fontPath}montserrat-v11-latin-700.woff) format('woff');
    }
    
    ${PrestoAppTheme.layout.globalBodyCSSString}
`;

const history = createHistory();
/*
const reactRouterMiddleware = routerMiddleware(history);

// Redux DevTools extension
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// https://stackoverflow.com/a/38074329/751634
// https://stackoverflow.com/questions/49072314
const enhancedCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    combineReducers({
        app: appReducer,
        router: routerReducer
    })
    ,
    enhancedCompose(
        applyMiddleware(
            reactRouterMiddleware
        )
    )
);
*/

const store = createStore(
    combineReducers({
        app: appReducer,
    })
);

const Root =  (
    <Provider store={store}>
        <ThemeProvider theme={PrestoAppTheme}>
            <Router history={history}>
                <App />
            </Router>
    </ThemeProvider>
    </Provider>
);

ReactDOM.render(Root, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
